import { INK } from '../themeConstants'

export const colorPalette = {
  mode: 'light',
  primary: { main: '#0078d4' },
  error: { main: '#c50f1f' },
  success: { main: '#107c10' },
  warning: { main: '#d83b01' },
  info: { main: '#0078d4' },
  /* Keep in sync with `--app-bg-default` / `--app-bg-panel` in scss/index.scss (spec: #ffffff). */
  background: {
    default: '#ffffff',
    paper: '#ffffff',
  },
  text: {
    primary: INK.primary,
    secondary: INK.secondary,
    tertiary: INK.tertiary,
    labelTag: INK.quaternary,
    disabled: INK.disabled,
  },
  divider: '#e4e4e7',
  action: {
    active: INK.primary,
    hover: 'rgba(0, 0, 0, 0.04)',
    selected: 'rgba(0, 0, 0, 0.06)',
    disabled: INK.disabled,
    disabledBackground: 'rgba(0, 0, 0, 0.06)',
    focus: 'rgba(0, 120, 212, 0.12)',
  },
}
